module.exports = __webpack_public_path__ + "static/media/cancel.2da10a50.svg";